import Introduce from 'components/3_Usage/3_1/Introduce'
import HowToCallARS from 'components/3_Usage/3_2/HowToCallARS'
import UsageTab from 'components/3_Usage/UsageTab'

const Usage = () => {
  return <UsageTab children={[<Introduce />, <HowToCallARS />]} />
}

export default Usage
